import NavPage, { NavPageProps } from "./NavPage";

export default function DetailPage<E>(props: NavPageProps<E>) {
  return <NavPage {...props} />;
}
